$('.add-coords').click (event) ->

fileObject = {}

$(document).ready ->
  STORY_FILE_LIMITS = $('#story_file_limits').val() && JSON.parse($('#story_file_limits').val())

  $('.edit-story-image-file').click (event) ->
    $(event.target).val('')
 
  $('.edit-story-image-file').click (event) ->
    $(event.target).val('')
    
  $('.edit-story-image-file').on 'drop', (event) ->
    $(event.target).val('')
 
  $('.edit-story-image-file').on 'drop', (event) ->
    $(event.target).val('')
          
  $('.back-story-image').click (event) ->
    $('body').prop('scrollTop', 0)
    close = '#editCropStoryImageModal-' + $((event.target)).attr("id")
    open = '#editModal-' + $((event.target)).attr("id")
    $('.darkroom-image-container').remove()
    $(close).foundation('reveal', 'close'); 
    $(open).foundation('reveal', 'open');    
    return
  
  $('.crop-image-back').click (event) ->
    $('body').prop('scrollTop', 0)
    close = '#editCropStoryImageModal-' + $((event.target)).attr("id")
    open = '#editModal-' + $((event.target)).attr("id")
    $('.darkroom-image-container').remove()
    $(close).foundation('reveal', 'close'); 
    $(open).foundation('reveal', 'open');    
    return     
  

  $(".edit-story-image-file").change (event) ->
    file_preview = $(event.target).siblings(".upload-preview-story-image").find("img")
    $(event.target).siblings(".edit-story-image-modal").css("display", "inline-block")

    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype_image = file.type;
    fileObject.filename_image = file.name;

    return if fileSizeNotInLimit(file,event,".edit-story-image-modal",STORY_FILE_LIMITS["image"])

    reader = new FileReader()
    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64

      return
    reader.readAsDataURL file
    return
    
  $(".edit-story-image-modal").click (event) ->
    cropbox = '#story_edit_image_cropbox' + "_" + $((event.target)).attr("id")
    $(cropbox).attr "src", $($(event.target)[0]).parent().children(".upload-preview-story-image").find("img").attr("src")

    $(".upload-preview").removeClass "upload-preview"
    $($(event.target)[0]).parent().children(".upload-preview-story-image").addClass "upload-preview"
    $('#editCropStoryImageModal-' + $((event.target)).attr("id")).find(".upload-preview-story-image").addClass "upload-preview"
    
  $('.remove-story-image').click (event) ->
    $($(event.target)[0]).siblings('.upload-preview-story-image').find("img").attr("src", null)
    $(event.target).siblings(".edit-story-image-modal").css("display", "none")
    return

  $('.story-sortable').sortable({
    cursor: "move"
  });
  current_value = 0 
  current_text = ""
  next_text = ""
  current_name = ""
  next_name = ""

  $(".order_story_number").focus (event) ->
    current_value = $(event.target).val()
    current_text = $(event.target).parent().siblings().first().html().trim()
    next_text = $(event.target).parent().siblings().first().html().trim()    
    current_name = $(event.target).attr("name")
    next_name = $(event.target).attr("name")    
    return

  $(".order_story_number").change (event) ->
    check = false
    if parseInt($(event.target).val(),10) <= parseInt(current_value,10)
      check = true
    if check == true      
      for key in $(".order_story_number")
        if $(key).html() != $(event.target).html()
          if (parseInt($(key).val(),10) < parseInt(current_value, 10) && parseInt($(key).val(),10) >= parseInt($(event.target).val(),10)) 
            current_text = next_text
            current_name = next_name

            next_text = $(key).parent().siblings().first().html().trim()
            next_name = $(key).attr("name")

            $(key).parent().siblings().first().html(current_text)
            $(key).attr("name",current_name)
        else
          $(key).parent().siblings().first().html(next_text)
          $(key).attr("name",next_name)        
          $(key).val(current_value)
    else
      count = 0
      prev = ""
      for key in $(".order_story_number")                      
        if count == 1
          $(prev).parent().siblings().first().html($(key).parent().siblings().first().html())
          $(prev).attr("name",$(key).attr("name"))        
          
        if ( parseInt($(key).val(),10) == parseInt($(event.target).val(),10) )
          if count == 0
            current_text = $(event.target).parent().siblings().first().html().trim()
            current_name = $(event.target).attr("name")        
          count++
          
        if count == 2          
          next_text = $(key).parent().siblings().first().html()
          next_name = $(key).attr("name")
          $(key).parent().siblings().first().html(current_text)
          $(key).attr("name",current_name)
          current_text = next_text
          current_name = next_name
          break
        prev = $(key)        
      $(event.target).val(current_value)
    return
    
  $('form[id^="edit_function_"]').submit (e) ->
    if $(this).hasClass('knowledge_item_form')
      return true
    e.preventDefault()
    story_image = ''
    story_runtime = ''
    
    if $(e.target).children(".q1").children(".upload-preview-story-image").find("img").attr('src') != undefined && $(e.target).children(".q1").children(".upload-preview-story-image").find("img").attr('src').indexOf("base64") != -1
      story_image = $(e.target).children(".q1").children(".upload-preview-story-image").find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg);base64,/, "")

    else if $(e.target).children(".q1").children(".upload-preview-story-image").find("img").attr('src') == undefined
      story_image = 'null'
      

    $.ajax(
      type: 'POST',
      url: "#{$(this).attr('action')}.json"
      enctype: 'multipart/form-data',
      dataType: 'json',
      data: 
        'story[custom_image][base64]': story_image
        'story[custom_image][filetype]': fileObject.filetype_image
        'story[custom_image][filename]': fileObject.filename_image
        'story[runtime]': $(".edit-story-runtime").val()
        'function[name]': $(e.target).children(".function-name").children('#function_name').val()
        'authenticity_token': $('input[name=authenticity_token]').val()
        '_method': 'patch'
    ).done((data, textStatus, jqXHR) ->
      window.location.href = window.location.href.split("#")[0]
      return
    ).fail((jqXHR, textStatus, errorThrown) ->
      $(e.target).find("input[type='submit']").attr("disabled",false)
      $(e.target).find("input[type = 'submit']").val("Update")
      alert (jqXHR.responseText)
      return
    )
    true
    
  return
          
